import { CardTemplate } from '~/editor/v2/cards/templates/types';
import { GLOBAL_PLACEHOLDER } from '~/editor/v2/cards/templates/constants';
import imageCardImage from '~/assets/editor/cards4-image-card.jpg';
import { pictureCardTextFields } from './pictureCardText';

export const imageCardTemplate: CardTemplate = {
  type: 'image',
  label: 'Image Card',
  cardImage: imageCardImage,

  fields: [
    {
      type: 'image',
      name: 'pictures',
      defaultValue: GLOBAL_PLACEHOLDER
    },
    ...pictureCardTextFields
  ],

  createModalTitle: 'New Image Card',
  editModalTitle: 'Edit Image Card'
};
